import { BillingApi } from '@/api/billing';
import { useQuery } from '@tanstack/react-query';
import { billingKeys } from './billing.keys';

export function useBillingAccount() {
  return useQuery({
    queryKey: billingKeys.account(),
    queryFn: BillingApi.getAccount,
  });
}
